<div class="col-auto years-select">
    <div class="dropdown-select">
        <div class="selected col-auto row" (click)="handleOnClickYearSelectDropdown();">
            <span class="col">{{ selectedYear.label }}</span>
            <svg class="col-auto" width="12" height="7" viewBox="0 0 12 7" fill="none">
                <path opacity="0.7" d="M1 1L6 6L11 1" stroke="#2A2E46" stroke-miterlimit="10" />
            </svg>
        </div>
        <ul class="options" [ngClass]="showYearOptions ? 'open-dropdown-select' : 'close-dropdown-select'">
            <ng-template ngFor let-item [ngForOf]="yearOptions">
                <li class="option" value="{{item.value}}" (click)="handleOnClickYearOption(item.value)">{{ item.label }}
                </li>
            </ng-template>
        </ul>
    </div>
</div>
<div class="col-auto months-select">
    <div class="dropdown-select">
        <div class="selected col-auto row" (click)="handleOnClickMonthSelectDropdown();">
            <span class="col" id="from-month-selected">{{ selectedMonth.label }}</span>
            <svg class="col-auto" width="12" height="7" viewBox="0 0 12 7" fill="none">
                <path opacity="0.7" d="M1 1L6 6L11 1" stroke="#2A2E46" stroke-miterlimit="10" />
            </svg>
        </div>
        <ul class="options" [ngClass]="showMonthOptions ? 'open-dropdown-select' : 'close-dropdown-select'">
            <ng-template ngFor let-item [ngForOf]="monthOptions">
                <li class="option" value="{{item.value}}" (click)="handleOnClickMonthOption(item.value)">{{ item.label
                    }}</li>
            </ng-template>
        </ul>
    </div>
</div>
<div class="col-auto days-select" *ngIf="hiddenDate === false">
    <div class="dropdown-select">
        <div class="selected col-auto row" (click)="handleOnClickDateSelectDropdown();">
            <span class="col" id="from-day-selected">{{ selectedDate.label }}</span>
            <svg class="col-auto" width="12" height="7" viewBox="0 0 12 7" fill="none">
                <path opacity="0.7" d="M1 1L6 6L11 1" stroke="#2A2E46" stroke-miterlimit="10" />
            </svg>
        </div>
        <ul class="options" [ngClass]="showDateOptions ? 'open-dropdown-select' : 'close-dropdown-select'">
            <ng-template ngFor let-item [ngForOf]="dateOptions">
                <li class="option" value="{{item.value}}" (click)="handleOnClickDateOption(item.value)">{{ item.label }}
                </li>
            </ng-template>
        </ul>
    </div>
</div>